/* AirFlow — harmonise delais + e-mail sur tout le site */
(function(){
  if(window.__afDeliv)return;window.__afDeliv=1;
  var rep=[['1 à 3 jours ouvrés','5 à 9 jours ouvrés'],['2 à 5 jours ouvrés','5 à 9 jours ouvrés'],['6 à 12 jours ouvrés','5 à 9 jours ouvrés'],['Expédition rapide','Livraison rapide'],['bonjour@airflow.fr','aroundtw.info@gmail.com'],['dylannhildebert@gmail.com','aroundtw.info@gmail.com']];
  function fixNode(t){var v=t.nodeValue,o=v;for(var i=0;i<rep.length;i++){v=v.split(rep[i][0]).join(rep[i][1]);}if(v!==o)t.nodeValue=v;}
  function fix(root){try{var wk=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;while(n=wk.nextNode())fixNode(n);}catch(e){}}
  function start(){
    fix(document.body);
    try{new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var a=ms[i].addedNodes;for(var j=0;j<a.length;j++){var nd=a[j];if(nd.nodeType===3)fixNode(nd);else if(nd.nodeType===1)fix(nd);}}}).observe(document.body,{childList:true,subtree:true});}catch(e){}
  }
  if(document.readyState!=='loading')start();else document.addEventListener('DOMContentLoaded',start);
})();
